import React, {useState, useEffect} from "react";
import AllLearnersSchedulerView from "./AllLearnersScheduleView";

const LearnersSchedule= ({InstituteAllStudentsSchedule}) => {
    
    return (
        <div className="w-full bg-[#FFFFFF] flex justify-center items-center mt-[50px]">
            <div className="w-[85%] flex flex-col gap-[50px]">
                <div className="w-full flex items-center gap-[40px]">
                        <div className="flex items-center gap-[10px]">
                            <div className="w-[24px] h-[24px] bg-[#0AA630]"></div>
                            <p className="text-[16px] text-[#404040]">In-Vehicle Hours</p>
                        </div>

                        <div className="flex items-center gap-[10px]">
                            <div className="w-[24px] h-[24px] bg-[#5298F5]"></div>
                            <p className="text-[16px] text-[#404040]">In-Class hours</p>
                        </div>

                        <div className="flex items-center gap-[10px]">
                            <div className="w-[24px] h-[24px] bg-[#FC0000]"></div>
                            <p className="text-[16px] text-[#404040]">Online/Other Hours</p>
                        </div>
                </div>

                <AllLearnersSchedulerView
                    InstituteAllStudentsSchedule={InstituteAllStudentsSchedule}
                />
            </div>
        </div>
    );
};

export default LearnersSchedule;
